import styled from "styled-components";

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 24px;
  align-items: center;
  gap: 32px;
`;

export default MainContainer;
